/**
 * Common Services' sign-out hand-off, for this product.
 *
 * Signing out (the Logout menu item, or a session that ended) goes to
 * VITE_OKTA_LOGOUT_LINK — Common Services' `?state=logout` — as legacy does
 * (Headerbar.vue:584, apiservice.js:200). Common Services clears its side and
 * then sends the user to the product named by `appName` (UI-Common-Services
 * rootLoader.js + config/applications.js `logoutUrl`; legacy router/index.js
 * `appRedirects`). Without `appName` it cannot tell which product called, and
 * the user is left on the Common Services home.
 *
 * The name is added here, not written into the env link: ONE build serves both
 * CCA and EIA, so it must come from the product resolved at runtime. Built with
 * URL so a link that already has `?state=logout` gets `&appName=`, and an
 * `appName` already in the link is replaced rather than sent twice.
 *
 * @param {string} logoutLink  env.csLogoutUrl (VITE_OKTA_LOGOUT_LINK)
 * @param {string} appName     the variant's shortName — 'CCA' | 'EIA'
 * @returns {string | null}    null when the link is unset or not http(s)
 */
export function buildCsLogoutUrl(logoutLink, appName) {
  if (!logoutLink) return null;
  try {
    const url = new URL(logoutLink);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
    if (appName) url.searchParams.set('appName', appName);
    return url.toString();
  } catch {
    return null;
  }
}
